// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Local Imports
import endPoints from '@/redux/constant';
import axios from '@/redux/http';
import { PURGE } from 'redux-persist';

// Initial State
const initialState = {
  loading: false,
  error: null,
  profile: null,
  cancelSubscriptionLoading: false,
  cancelSubscriptionError: null,
  renewSubscriptionLoading: false,
  renewSubscriptionError: null,
};

// Update Dashboard Profile API Fn
export const updateProfileAPIFn = createAsyncThunk(
  'update/profileDetails',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(endPoints.updateProfileData, {
        ...values,
      });

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Get Profile Details
export const getProfileAPIFn = createAsyncThunk(
  'get/profileDetails',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${endPoints.getProfileData}?userId=${values?.userId}`, {
        ...values,
      });

      return data?.result;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Cancel Subscription
export const cancelSubscriptionAPIFn = createAsyncThunk(
  'cancelSubscription',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${endPoints.cancelSubscription}?userId=${values?.userId}`, {
        ...values,
      });

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Renew Subscription
export const renewSubscriptionAPIFn = createAsyncThunk(
  'renewSubscription',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${endPoints.renewSubscription}?userId=${values?.userId}`, {
        ...values,
      });

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Login User Slices
export const dashboardProfileSlice = createSlice({
  name: 'dashboard/profile',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(updateProfileAPIFn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfileAPIFn.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateProfileAPIFn.rejected, (state) => {
        state.loading = false;
        state.profile = null;
      })
      .addCase(getProfileAPIFn.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.profile = null;
      })
      .addCase(getProfileAPIFn.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
        state.error = null;
      })
      .addCase(getProfileAPIFn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.profile = null;
      })
      .addCase(cancelSubscriptionAPIFn.pending, (state) => {
        state.cancelSubscriptionLoading = true;
        state.cancelSubscriptionError = null;
      })
      .addCase(cancelSubscriptionAPIFn.fulfilled, (state) => {
        state.cancelSubscriptionLoading = false;
        state.cancelSubscriptionError = null;
      })
      .addCase(cancelSubscriptionAPIFn.rejected, (state, action) => {
        state.cancelSubscriptionLoading = false;
        state.cancelSubscriptionError = action.payload;
      })
      .addCase(renewSubscriptionAPIFn.pending, (state) => {
        state.renewSubscriptionLoading = true;
        state.renewSubscriptionError = null;
      })
      .addCase(renewSubscriptionAPIFn.fulfilled, (state) => {
        state.renewSubscriptionLoading = false;
        state.renewSubscriptionError = null;
      })
      .addCase(renewSubscriptionAPIFn.rejected, (state, action) => {
        state.renewSubscriptionLoading = false;
        state.renewSubscriptionError = action.payload;
      })
      .addCase(PURGE, (state) => {
        state.loading = false;
        state.error = null;
        state.profile = null;
      });
  },
});

export default dashboardProfileSlice.reducer;